import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TEXT_FIELD_STATUS, CONTEXT_PROVIDERS, publicHash, ERROR, SUCCESS } from '../../utils/constants';
import EmailField from '../../components/_molecules/EmailField/EmailField';
import Button from '../../components/_atomic/Button/Button';
import CustomRRLink from '../../components/_atomic/CustomRRLink/CustomRRLink';
import ErrorModal from '../../components/_molecules/ErrorModal/ErrorModal';
import LinkButton from '../../components/_atomic/LinkButton/LinkButton';
import RestoreFormContext from './RestoreFormContext';
import './RestorePassword.scss';
// yes, we can create components for form, but it's take more time for extracting
// main functions
const emailFieldName = 'email';

class RestorePassword extends Component {
  static propTypes = {
    status: PropTypes.string.isRequired,
    requestEmail: PropTypes.func.isRequired,
    error: PropTypes.string.isRequired,
    annulError: PropTypes.func.isRequired,
  };
  constructor() {
    super();
    this.fields = {};
  }

  state = {
    formStatus: TEXT_FIELD_STATUS.INITIAL,
    fields: {
      [emailFieldName]: {
        status: TEXT_FIELD_STATUS.INITIAL,
        isFocused: false,
        value: '',
        errorText: '',
        hint: '',
        needValidator: false,
      },
    },
  }

  getFormStatus = (fields) => {
    let status = TEXT_FIELD_STATUS.INITIAL;
    let validFields = 0;
    let invalidFields = 0;
    const fieldsNames = Object.keys(fields);
    /* calc invalid fields coz form can have one VALID and one INITIAL field
           then form isn't valid or invalid it is initial */
    fieldsNames.forEach((name) => {
      if (fields[name].status === TEXT_FIELD_STATUS.VALID) {
        validFields += 1;
      }
      if (fields[name].status === TEXT_FIELD_STATUS.INVALID) {
        invalidFields += 1;
      }
    });
    if (validFields === fieldsNames.length) {
      status = TEXT_FIELD_STATUS.VALID;
    }

    if (invalidFields > 0) {
      status = TEXT_FIELD_STATUS.INVALID;
    }
    return status;
  };
  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
  };

  fieldChangeHandler = ({ name, value }) => {
    const fields = {
      ...this.state.fields,
    };
    let { formStatus } = this.state;
    fields[name].value = value;

    if (fields[name].status !== TEXT_FIELD_STATUS.INITIAL) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }

    this.setState(() => ({ fields, formStatus }));
  };

  fieldFocusHandler = ({ name, isFocused }) => {
    const fields = {
      ...this.state.fields,
    };
    let { formStatus } = this.state;
    fields[name].isFocused = isFocused;
    if (!isFocused) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }
    this.setState(() => ({ fields, formStatus }));
  };
  submitHandler = (e) => {
    e.preventDefault();
    const fields = {
      ...this.state.fields,
    };
    Object
      .keys(this.fields)
      .forEach((name) => {
        const { validator } = this.fields[name];
        const validate = validator(fields[name].value);
        fields[name].status = validate.status;
        fields[name].errorText = validate.errorText;
      });
    const formStatus = this.getFormStatus(fields);
    this.setState(() => ({ fields, formStatus }), () => {
      if (formStatus === TEXT_FIELD_STATUS.VALID) {
        const data = {
          email: fields[emailFieldName].value,
        };
        this.props.requestEmail(data);
      }
    });
  }
  render() {
    const { status, error, annulError } = this.props;
    const { formStatus, fields } = this.state;
    const isError = status === ERROR;
    const disabledButton = formStatus === TEXT_FIELD_STATUS.INVALID;
    const emailField = fields[emailFieldName];
    const restoreFormWrapperClassnames = classNames({
      'restore-form-wrapper': true,
      confirmed: status === SUCCESS,
    });
    return (
      <div className={restoreFormWrapperClassnames}>
        <div className="restore-form-content">
          <form className="restore-form">
            <ErrorModal requestClose={annulError} visible={isError} error={error} />

            <div className="main-label">
              <span>Reset Password</span>
            </div>
            <div className="form-description">
              <span>
                We’ll send you a letter with the link to reset your password on your email.
              </span>
            </div>
            <RestoreFormContext.Provider
              value={{
              register: this.registerField,
              changeHandler: this.fieldChangeHandler,
              focusHandler: this.fieldFocusHandler,
            }}
            >
              <EmailField
                name={emailFieldName}
                value={emailField.value}
                status={emailField.status}
                isFocused={emailField.isFocused}
                errorText={emailField.errorText}
                hint={emailField.hint}
                isRequired
                needSpecifiedValidator
                contextProvider={CONTEXT_PROVIDERS.RestoreFormContext}
              />
            </RestoreFormContext.Provider>
            <div className="button-wrapper">
              <Button
                disabled={disabledButton}
                label="Restore Password"
                clickHandler={this.submitHandler}
              />
            </div>
            <div className="link-wrapper">
              <CustomRRLink to={`${publicHash}/auth/login`} text="I remember my password" />
            </div>
          </form>
          <div className="confirmation-wrapper">
            <div className="main-label">We sent you a letter</div>
            <div className="form-description">
              <span>
                We’ve sent you a letter with a link. Please check your email and follow the link
                to reset your password
              </span>
            </div>
            <div className="link-wrapper">
              <LinkButton clickHandler={annulError} text="Send me one more" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RestorePassword;



// WEBPACK FOOTER //
// ./src/containers/RestorePassword/RestorePassword.js